import { Grid, ListItemButton } from "@mui/material";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import "../ReportsHeader.css";
import {
  bindTrigger,
  bindPopover,
  usePopupState,
} from "material-ui-popup-state/hooks";
import { Button, List, ListItem, ListItemText } from "@material-ui/core";
import { GeneralDateRangePicker } from "../../../Components/GeneralComponents/GeneralDateRangePicker";
import moment from "moment";
import { useState } from "react";
import MaterialSelect from "./../../../Components/SelectDropdown/MaterialSelect";
import ExportTable from "../../../Components/Export/ExportTable";
import exportFromJSON from "export-from-json";
import { GeneralDateRangePickerForReport } from "../../../Components/GeneralComponents/GeneralDateRangePickerForReport";
const fileName = "download";
const exportType = exportFromJSON.types.csv;

export const ShareIssuanceHeader = (props) => {
  const {
    setTabValue,
    tableData,
    tabValue,
    selectValue,
    setSelectValue,
    finalData,
    setData,
    tableRef,
  } = props;

  const [filterDate, setFilterDate] = useState({});

  const handleTabValue = (e) => {
    setTabValue(e.target.innerText);
    // console.log(e.target.value);
  };
  // console.log(tabValue);
  // onChange={handleTabValue}

  const options = [
    "All Certificates",
    "Valid Certificates",
    "Invalid Certificates",
  ];
  const [secondary, setSecondary] = useState(false);
  const [dense, setDense] = useState(false);
  const ListItemForHeader = [
    "Today",
    "Yesterday",
    "This Week",
    "Previous Week",
    "Last 30 Days",
  ];

  const handleClickOnRightButton = (e) => {
    setSelectValue(e.target.innerText);
    handleClose();
    if (e.target.innerText === "Custom") popupState.open(anchorElD);
    switch (e.target.innerText) {
      case "Today":
        setData({
          startDate: moment().format("YYYY MM DD"),
          endDate: moment().format("YYYY MM DD"),
        });
        break;
      case "Yesterday":
        setData({
          startDate: moment().add(-1, "days").format("YYYY MM DD"),
          endDate: moment().add(-1, "days").format("YYYY MM DD"),
        });
        break;
      case "This Week":
        const today = moment();
        setData({
          startDate: today.startOf("week").format("YYYY MM DD"),
          endDate: today.endOf("week").format("YYYY MM DD"),
        });

        break;
      case "Previous Week":
        const day = moment().add(-7, "days");
        setData({
          startDate: day.startOf("week").format("YYYY MM DD"),
          endDate: day.endOf("week").format("YYYY MM DD"),
        });
        break;
      case "Last 30 Days":
        setData({
          startDate: moment().add(-30, "days").format("YYYY MM DD"),
          endDate: moment().format("YYYY MM DD"),
        });
        break;

      default:
        break;
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElD, setAnchorElD] = useState(null);
  const popupState = usePopupState({
    variant: "popover",
    popupId: "demoPopover",
  });

  const handlePopOver = (event) => {
    setAnchorEl(event.currentTarget);
    setAnchorElD(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseD = () => {
    setAnchorElD(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const openD = Boolean(anchorElD);
  const idD = openD ? "simple-popover" : undefined;

  return (
    <div style={{ margin: "20px 30px" }}>
      <Grid
        // container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderColor: "grey.500",
        }}
      >
        <Grid md={3}>
          {/* <Grid sx={{ fontSize: "1.4rem" }}>
            <MaterialSelect
              option_users={options}
              optionVal={tabValue}
              filterUsers={setTabValue}
            /> */}
          {/* <div
            className="shareissuanceHeading"
            style={{
              fontSize: "23px",
              fontFamily: "Mulish",
              fontStyle: "normal",
              fontWeight: "600",
              color: "#585858",
            }}
          >
            Share Issuance
          </div> */}

          <Grid sx={{ fontSize: "1.4rem" }}>
            <MaterialSelect
              option_users={options}
              optionVal={tabValue}
              filterUsers={setTabValue}
            />
          </Grid>
        </Grid>
        {/* <Grid sx={{ fontSize: "1.4rem" }}>
            {" "}
            <select onChange={handleTabValue}>
              {options.map((item) => (
                <option
                  style={{
                    fontSize: "20px",
                    textAlign: "center",
                  }}
                >
                  {item}
                </option>
              ))}
            </select>
          </Grid> */}
        {/* </Grid> */}

        <Grid
          spacing={1}
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            m: 1,
            mr: 5.2,
            justifyContent: "space-between",
            gap: "20px",
          }}
        >
          <Grid
            sx={{
              background: "#0096FF!important",
              borderRadius: "5px",
            }}
          >
            <>
              {/* <ExportTable
              data={finalData.map((ele) => {
                return {
                  Date: moment(ele.createdAt.slice(0, -1)).format("DD/MM/yyyy"),
                  TransactionId: ele.id,
                  MembershipId: ele.toMemberId.memberId,
                  memberName:
                    ele.toMemberId.firstName + " " + ele.toMemberId.lastName,
                  noOfShares: ele.noOfShares || "0",
                  shareType: ele.transactionId[0]?.typeOfShares,
                  amount:
                    ele?.transactionId[0]?.pricePerShare * ele.noOfShares ||
                    "0",
                  // ValidCertNo: ele?.transactionId
                  //   .map((ele) => {
                  //     if (ele.status) {
                  //       return ele.shareCertificationNo;
                  //     }
                  //   })
                  //   .filter((e) => {
                  //     return e != undefined;
                  //   })
                  //   .join(","),
                  // InValidCertNo: ele?.transactionId
                  //   .map((ele) => {
                  //     if (!ele.status) {
                  //       return ele.shareCertificationNo;
                  //     }
                  //   })
                  //   .filter((e) => {
                  //     return e;
                  //   })
                  //   .join(","),
                };
              })}
            /> */}
              <div
                className="exportBtn"
                style={{
                  background: "#0096FF!important",
                }}
                onClick={() => {
                  exportFromJSON({
                    data: tableRef?.current?.state?.data?.map((ele) => {
                      return {
                        transactionDate: ele.createdAt,
                        _id: ele._id,
                        toMemberId: ele?.toMemberId?.memberId?.trim(),
                        toMemberType: ele?.toMemberId?.member?.trim(),
                        toMemberShareHolder: ele?.toMemberId?.shareholder?.trim(),
                        toFirstName: ele?.toMemberId?.firstName?.trim(),
                        toMiddleName: ele?.toMemberId?.middleName?.trim(),
                        toLastName: ele?.toMemberId?.lastName?.trim(),
                        toPhone: ele?.toMemberId?.phone,
                        toEmail: ele?.toMemberId?.email?.trim(),
                        toAddressLine_1: ele?.toMemberId?.addressLine_1?.trim(),
                        toAddressLine_2: ele?.toMemberId?.addressLine_2?.trim(),
                        toState: ele?.toMemberId?.state?.trim(),
                        toDistrict: ele?.toMemberId?.district?.trim(),
                        toTaluka: ele?.toMemberId?.taluka?.trim(),
                        toCity: ele?.toMemberId?.city?.trim(),
                        toPincode: ele?.toMemberId?.pincode,
                        toOrganisationName: ele?.toMemberId?.organisation_name?.trim(),
                        toActivityStatus: ele?.toMemberId?.activityStatus,
                        toMobileSignUpStatus:
                          ele?.toMemberId?.mobileSignUpStatus,
                        toTotalShare: ele?.toMemberId?.totalShare,
                        toShareCapital: ele?.toMemberId?.shareCapital,
                        toShareApplicationMoney:
                          ele?.toMemberId?.shareApplicationMoney,
                        noOfShares: ele.noOfShares,
                        shareType: ele?.transactionId[0]?.typeOfShares,
                        amount:
                          parseInt(ele?.transactionId[0]?.pricePerShare) *
                            parseInt(ele?.noOfShares) || 0,
                            validCertificates: ele?.transactionId
                            .map((e) => {
                              if (e?.isValid) {
                                return e?.shareCertificationNo;
                              }
                            })
                            .filter((e) => {
                              return e != undefined;
                            })
                            .join(", "),
                          invalidCertificates: ele?.transactionId
                            .map((e) => {
                              if (!e.isValid) {
                                return e?.shareCertificationNo;
                              }
                            })
                            .filter((e) => {
                              return e != undefined;
                            })
                            .join(", "),
                      };
                    }),
                    fileName,
                    exportType,
                  });
                }}
              >
                <i
                  className="fa fa-download"
                  style={{
                    color: "#ffffff",
                    fontSize: "22px",
                    background: "#0096FF!important",
                  }}
                ></i>
              </div>
            </>
          </Grid>

          <div
            style={{
              textTransform: "capitalize",
            }}
          >
            <button
              aria-describedby={id}
              className="btnHover"
              onClick={handlePopOver}
              style={{
                outline: "none",
                border: "none",
                fontSize: "20px",
                background: "#0096FF",
                borderRadius: "5px",
                color: "#FFFFFF",
                padding: "5px 15px",
                textTransform: "capitalize",
              }}
            >
              {selectValue}
              <i
                className={open ? "fa fa-caret-up" : "fa fa-caret-down"}
                style={{ marginLeft: 10 }}
              />
            </button>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <Typography sx={{ p: 2 }}>
                <List dense={dense}>
                  {ListItemForHeader.map((value) => {
                    return (
                      <ListItem>
                        <ListItemButton
                          onClick={handleClickOnRightButton}
                          sx={{
                            textTransform: "capitalize",
                          }}
                        >
                          <ListItemText
                            primary={value}
                            secondary={secondary ? "Secondary text" : null}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                  <ListItem>
                    {/* <PopupState variant="popover" popupId="demo-popup-popover"> */}
                    {/* {(popupState) => ( */}
                    {/* <div> */}
                    <ListItemButton
                      onClick={handleClickOnRightButton}
                      // {...bindTrigger(popupState)}
                      sx={{
                        textTransform: "capitalize",
                      }}
                    >
                      <ListItemText
                        primary={"Custom"}
                        // onClick={handleClickOnRightButton}
                        secondary={secondary ? "Secondary text" : null}
                      />
                    </ListItemButton>
                    {/* </div> */}
                    {/* )} */}
                    {/* </PopupState> */}
                  </ListItem>
                </List>
              </Typography>
            </Popover>
            <Popover
              id={idD}
              open={openD}
              anchorEl={anchorElD}
              onClose={handleCloseD}
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <Typography
                sx={{ p: 2 }}
                style={{
                  // height: "85vh",
                  width: "46.5vw",
                  // minHeight: "20vh",
                }}
              >
                {/* <GeneralDateRangePicker
                  setData={setData}
                  handleCloseD={popupState.close}
                /> */}
                <GeneralDateRangePickerForReport
                  setData={setData}
                  setFilterDate={setFilterDate}
                  filterDate={filterDate}
                  handleCloseD={popupState.close}
                />
              </Typography>
            </Popover>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
